import { render, staticRenderFns } from "./WhatWeDo.vue?vue&type=template&id=557bb3f4&scoped=true&lang=pug"
import script from "./WhatWeDo.vue?vue&type=script&lang=js"
export * from "./WhatWeDo.vue?vue&type=script&lang=js"
import style0 from "./WhatWeDo.vue?vue&type=style&index=0&id=557bb3f4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557bb3f4",
  null
  
)

export default component.exports